import { render, staticRenderFns } from "./LabelGenerator.vue?vue&type=template&id=6ae85ab4&scoped=true"
import script from "./LabelGenerator.vue?vue&type=script&lang=js"
export * from "./LabelGenerator.vue?vue&type=script&lang=js"
import style0 from "./LabelGenerator.vue?vue&type=style&index=0&id=6ae85ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae85ab4",
  null
  
)

export default component.exports